/** One of the three statuses the opener (mobile eligibility verdict) reports per required training. */
export type TrainingStatus = 'valid' | 'needed' | 'expired';

export interface RequiredTraining {
  hazardProfileId: string;
  status: TrainingStatus;
}

export interface HandoffParams {
  handoff: string | null;
  trainings: RequiredTraining[];
  returnUrl: string | null;
  inquiryId: string | null;
  /** Embed channel, e.g. 'web' when the player runs inside the web account iframe; null on mobile. */
  embed: string | null;
  /** Absolute origin of the framing app (e.g. http://localhost:3111); echoed into postMessage targets. */
  parentOrigin: string | null;
}

const STATUSES: readonly TrainingStatus[] = ['valid', 'needed', 'expired'];

function coerceStatus(raw: string | undefined): TrainingStatus {
  return STATUSES.includes(raw as TrainingStatus) ? (raw as TrainingStatus) : 'needed';
}

/** Parse the opener's query string. `profiles` + `statuses` are positionally-aligned CSV lists. */
export function parseHandoffParams(search: string): HandoffParams {
  const params = new URLSearchParams(search);
  const profiles = (params.get('profiles') ?? '')
    .split(',')
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
  const statuses = (params.get('statuses') ?? '').split(',').map((s) => s.trim());

  const trainings: RequiredTraining[] = profiles.map((hazardProfileId, i) => ({
    hazardProfileId,
    status: coerceStatus(statuses[i]),
  }));

  return {
    handoff: params.get('handoff'),
    trainings,
    returnUrl: params.get('return'),
    inquiryId: params.get('inquiryId'),
    embed: params.get('embed'),
    parentOrigin: params.get('parentOrigin'),
  };
}
